/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyStock from './pharmacy-stock';
import PharmacyStockDetail from './pharmacy-stock-detail';
import PharmacyStockUpdate from './pharmacy-stock-update';
import PharmacyStockDeleteDialog from './pharmacy-stock-delete-dialog';

const PharmacyStockRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyStock />} />
    <Route path="new" element={<PharmacyStockUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyStockDetail />} />
      <Route path="edit" element={<PharmacyStockUpdate />} />
      <Route path="delete" element={<PharmacyStockDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyStockRoutes;
